import PortalIdContainer from '../portal-id-container/PortalIdContainer';
import { setPortalId } from '../store/auth/action-creators';
import UsageTrackerContainer from '../tracking/UsageTrackingContainer';
export const setNewPortalId = ({
  hubId,
  hublet
}, dispatch) => {
  PortalIdContainer.set(hubId);
  UsageTrackerContainer.setProperties({
    hubId,
    hublet
  });
  dispatch(setPortalId(hubId));
};